import React from 'react';
import { Link } from 'react-router-dom';
import { UIHeading2, UIHeading1, useDeviceType } from '@cian/ui-kit';

import { IMainNews } from '../../types/mainNews';
import { NewsItem } from './components/NewsItem';
import { NEWS_RSS_FEED_LINK } from '../../constants';
import * as s from './MainNews.css';

/** Блок новостей на Главной */
export const MainNews = ({ items }: IMainNews) => {
  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';
  const HeadingComponent = isPhone ? UIHeading2 : UIHeading1;

  return (
    <div className={s['wrapper']} data-web-ui-test-id="MainNews">
      <div className={s['header-wrapper']}>
        <Link to={`/novosti/`} className={s['header-link']} data-web-ui-test-id="LinkTitleNews">
          <HeadingComponent>Новости</HeadingComponent>
        </Link>

        <a className={s['rss']} href={NEWS_RSS_FEED_LINK} target={'_blank'} rel="noreferrer">
          RSS
        </a>
      </div>

      <div className={s['items-wrapper']}>
        {items.map(item => (
          <NewsItem key={`news-${item.id}`} {...item} />
        ))}
      </div>

      <div className={s['more-link-wrapper']}>
        <div className={s['gradient']} />

        <Link to={`/novosti/`} data-web-ui-test-id={'LinkAllNews'} className={s['more-link']}>
          Все новости
        </Link>
      </div>
    </div>
  );
};
